import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Image, Tabs, Tab } from 'react-bootstrap';
import { useUserContext } from '../UserContext'; // Para obter permissões no futuro
import logoImage from '../img/logo.png';
import TagsInteresseTab from '../components/configuracoes/TagsInteresseTab'; // Importa o componente da aba
import ComunicadosConfigTab from '../components/configuracoes/ComunicadosConfigTab';
import AgendasConfigTab from '../components/configuracoes/AgendasConfigTab'; // 1. Importar a nova aba de agendas
import LayoutEntidadeTab from '../components/configuracoes/LayoutEntidadeTab'; // Importar a nova aba de layout
import RedesSociaisTab from '../components/configuracoes/RedesSociaisTab'; // Importar a nova aba de Redes Sociais
import EntidadeTab from '../components/configuracoes/EntidadeTab'; // Importar a nova aba de layout
import ConexoesTab from '../components/configuracoes/ConexoesTab'; // Importar a nova aba de layout

import ContratoTemplateTab from '../components/configuracoes/ContratoTemplateTab'; // Importar a nova aba de template de contrato
import AnamneseTab from '../components/configuracoes/AnamneseTab'; // Importar a nova aba de anamnese

const ConfiguracoesPage = () => {
    // No futuro, você pode usar o contexto para obter abas permitidas dinamicamente
    // const { currentUserRole, getPermittedInternalTabs } = useUserContext();
    // const permittedTabs = useMemo(() => getPermittedInternalTabs('configuracoes', currentUserRole), [currentUserRole, getPermittedInternalTabs]);
    
    // Por enquanto, usaremos uma lista estática de abas
    const permittedTabs = [
        { key: 'entidade', title: 'Entidade' },
        { key: 'conexoes', title: 'Conexões' },
        { key: 'tagsInteresse', title: 'Tags de Interesse' },
        { key: 'comunicacao', title: 'Comunicação' },
        { key: 'agendas', title: 'Agendas' }, // 2. Adicionar a nova aba à lista
        { key: 'layout', title: 'Layout da Entidade' },
        { key: 'redesSociais', title: 'Redes Sociais' },
        { key: 'contratoTemplate', title: 'Contrato Template' },
        { key: 'anamnese', title: 'Perguntas de Anamnese' },
        // Adicione outras abas de configuração aqui no futuro
    ];

    const [activeTabKey, setActiveTabKey] = useState(permittedTabs[0]?.key || '');

    return (
        <div style={{ border: '1px solid gray', backgroundColor: '#f5f5f5' }}>
            <div className="header" style={{ minHeight: '80px' }}> 
                <Row className="p-1 align-items-center" style={{ minHeight: 'inherit' }}>
                    <Col xs={12} md={6} style={{ minHeight: '60px' }}>
                        <div className="d-flex align-items-center justify-content-start h-100">
                            <Image src={logoImage} alt="Logo Clínica" style={{ maxHeight: '60px', marginLeft: '12px' }} />
                            <h3 style={{ marginLeft: '15px', marginBottom: '0' }}>Empresa</h3> 
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="body p-3">
                <Tabs activeKey={activeTabKey} onSelect={(k) => setActiveTabKey(k)} className="mb-3">
                    {permittedTabs.map(tabInfo => (
                        <Tab key={tabInfo.key} eventKey={tabInfo.key} title={tabInfo.title}>
                            {/* Renderiza o conteúdo com base na chave da aba ativa */}
                            {activeTabKey === 'entidade' && tabInfo.key === 'entidade' && <EntidadeTab />}
                            {activeTabKey === 'conexoes' && tabInfo.key === 'conexoes' && <ConexoesTab />}
                            {activeTabKey === 'tagsInteresse' && tabInfo.key === 'tagsInteresse' && <TagsInteresseTab />}
                            {activeTabKey === 'comunicacao' && tabInfo.key === 'comunicacao' && <ComunicadosConfigTab />}
                            {activeTabKey === 'agendas' && tabInfo.key === 'agendas' && <AgendasConfigTab />}
                            {activeTabKey === 'layout' && tabInfo.key === 'layout' && <LayoutEntidadeTab />}
                            {activeTabKey === 'redesSociais' && tabInfo.key === 'redesSociais' && <RedesSociaisTab />}
                            {activeTabKey === 'contratoTemplate' && tabInfo.key === 'contratoTemplate' && <ContratoTemplateTab />}
                            {activeTabKey === 'anamnese' && tabInfo.key === 'anamnese' && <AnamneseTab />}
                        </Tab>
                    ))}
                </Tabs>
            </div>
        </div>
    );
};

export default ConfiguracoesPage;